import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import RoutesList from '@/components/RoutesList.vue';
let Rules = class Rules extends Vue {
    get categories() {
        return [
            {
                routes: [
                    { to: '/rules/phb', title: 'Player\'s Handbook' },
                    { to: '/rules/snv', title: 'Scum and Villainy' },
                    { to: '/rules/sotg', title: 'Starships of the Galaxy' },
                    { to: '/rules/wh', title: 'Wretched Hives' },
                    { to: '/rules/variantRules', title: 'Variant Rules' },
                    { to: '/rules/expandedContent', title: 'Expanded Content' }
                ]
            }
        ];
    }
};
Rules = __decorate([
    Component({
        components: {
            RoutesList
        }
    })
], Rules);
export default Rules;
